"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WomanOutline = {
    name: 'woman',
    theme: 'outline',
    nameWithTheme: 'woman-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M909.7 156.6l-42.2-42.2c-3.1-3.1-8.2-3.1-11.3 0L764 206.6l-84.2-84.2c-3.1-3.1-8.2-3.1-11.3 0l-42.1 42.1c-3.1 3.1-3.1 8.1 0 11.3l84.2 84.2-135.5 135.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S112 547.1 112 624s30 149.3 84.4 203.6C250.7 882 323.1 912 400 912s149.3-30 203.6-84.4C658 773.3 688 700.9 688 624c0-64.2-20.9-125.1-59.3-175.1l135.4-135.4 84.2 84.2c3.1 3.1 8.2 3.1 11.3 0l42.1-42.1c3.1-3.1 3.1-8.1 0-11.3l-84.2-84.2 92.2-92.2c3.1-3.1 3.1-8.2 0-11.3zM400 836c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'
            },
            children: []
        }
    ]
};
exports.default = WomanOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/outline/WomanOutline.js
// module id = 847
// module chunks = 0 1